<template>
  <div class="w-full h-full">
    <InstructorHeader v-if="this.userInfo.user.permission == 'instructor'" />
    <HodHeader v-if="this.userInfo.user.permission == 'hod'" />
    <CoordinateHeader v-if="this.userInfo.user.permission == 'co-ordinator'" />
    <AdminHeader v-if="this.userInfo.user.permission == 'super_admin'" />

    <FlashMessage v-if="this.messages.text != ''" :message="this.messages" />
    <!-- old preview -->

    <div
      class="w-full max-w-7xl mx-auto flex flex-col gap-4 h-full hidden"
      v-if="dataval != null"
    >
      <div>
        <button
          @click="$router.go(-1)"
          class="bg-blues text-white px-4 font-semibold text-sm py-1 rounded-xl mt-10 mx-10"
        >
          Back
        </button>
      </div>
      <div class="overflow-y-auto pb-10">
        <div
          v-for="(el, index) in dataval.coursequizusersanswer_set"
          :key="el"
          class="border max-w-4xl mx-auto mt-4 text-start p-10 rounded-3xl"
        >
          <p class="py-2 font-bold">
            {{ index + 1 }}) {{ el.question.question_text }}
          </p>

          <div
            v-for="(al, index) in el.question.coursequizanswer_set"
            :key="al"
          >
            <p
              class
              :class="[al.is_correct == true ? 'text-blue-900 font-bold' : '']"
            >
              {{ index + 1 }}) {{ al.answer_text }}
              <br />
            </p>
          </div>

          <div
            v-if="el.question.choice_type === 'choice'"
            class="px-6 mt-6 py-6 rounded-2xl border my-2"
          >
            <h1
              class="px-5 lg:px-5 py-2 lg:py-4 items-center border-gray-200 bg-gray-100 text-xs font-semibold rounded-2xl text-gray-600 tracking-wider"
            >
              Your Answer :
            </h1>
            <p
              v-if="el.answer"
              class="px-4 text-sm font-bold mt-2"
              :class="[
                el.answer.is_correct == true
                  ? 'text-green-700'
                  : 'text-red-400',
              ]"
            >
              {{ el.answer.answer_text }}
            </p>
            <p v-else class="px-4 text-sm font-bold">Not attend</p>
          </div>

          <div
            v-if="el.question.choice_type === 'description'"
            class="px-6 mt-6 py-6 rounded-2xl border my-2"
          >
            <h1
              class="px-5 lg:px-5 py-2 lg:py-4 items-center border-gray-200 bg-gray-100 text-xs font-semibold rounded-2xl text-gray-600 tracking-wider"
            >
              Your Answer
            </h1>
            <p
              v-if="el.description != null"
              class="px-4 text-sm font-bold mt-2"
            >
              {{ el.description }}
            </p>
          </div>

          <div
            v-if="el.question.choice_type === 'shortdescription'"
            class="px-6 mt-6 py-6 rounded-2xl border my-2"
          >
            <h1
              class="px-5 lg:px-5 py-2 lg:py-4 items-center border-gray-200 bg-gray-100 text-xs font-semibold rounded-2xl text-gray-600 tracking-wider"
            >
              Your Answer
            </h1>
            <p
              v-if="el.short_description != null"
              class="px-4 text-sm font-bold mt-2"
            >
              {{ el.short_description }}
            </p>
          </div>
          <div
            v-if="el.question.choice_type === 'coding'"
            class="px-6 mt-6 py-6 rounded-2xl border my-2"
          >
            <div
              class="w-full bg-gray-900 text-white rounded-lg overflow-hidden"
            >
              <!-- Header -->
              <div
                class="flex justify-between items-center px-5 py-3 bg-gray-800 border-b border-gray-700"
              >
                <div class="flex items-center gap-4">
                  <h3 class="text-sm font-semibold">Code Editor</h3>
                  <input
                    type="text"
                    :value="el.question.programming_language"
                    class="px-3 py-1.5 border border-gray-700 rounded bg-gray-700 text-white text-xs outline-none cursor-not-allowed"
                    disabled
                  />
                </div>
              </div>

              <div class="flex" style="height: 400px">
                <!-- Left Side - Code Editor -->
                <div
                  class="flex-1 flex flex-col overflow-hidden border-r border-gray-700"
                >
                  <div
                    class="flex justify-between items-center px-4 py-2 bg-gray-800 border-b border-gray-700 text-xs font-semibold"
                  >
                    <span>📝 Submitted Code</span>
                  </div>

                  <MonacoEditor
                    :value="el.coding || '// No code submitted'"
                    :language="el.question.programming_language"
                    height="100%"
                    theme="vs-dark"
                    :options="{
                      readOnly: true,
                      minimap: { enabled: false },
                      scrollBeyondLastLine: false,
                      fontSize: 13,
                      lineNumbers: 'on',
                      glyphMargin: false,
                      lineDecorationsWidth: 0,
                      lineNumbersMinChars: 3,
                      renderLineHighlight: 'none',
                      contextmenu: false,
                      cursorStyle: 'line-thin',
                    }"
                    class="flex-1"
                  />
                </div>

                <!-- Right Side - Output -->
                <div class="flex-1 flex flex-col overflow-hidden">
                  <div
                    class="flex justify-between items-center px-4 py-2 bg-gray-800 border-b border-gray-700 text-xs font-semibold"
                  >
                    <span>📤 Output</span>
                  </div>
                  <div class="flex-1 p-4 overflow-y-auto bg-gray-900">
                    <div
                      v-if="el.output"
                      class="font-mono text-xs whitespace-pre-wrap leading-relaxed text-gray-300"
                    >
                      {{ formatOutput(el.output) }}
                    </div>
                    <div
                      v-else
                      class="text-gray-500 italic text-center mt-12 text-xs"
                    >
                      No output available
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- <div
                  class="flex flex-wrap justify-center gap-4 w-full"
                  v-if="el.question.choice_type == 'truefalse'"
                >
                  <button
                    style="border: 1px solid #01b0f9"
                    class="border rounded py-3 px-4 w-5/12 relative text-sm hover:bg-blue-900 hover:text-white"
                    :class="[
                      el.question.ansclk == option.id
                        ? 'bg-blue-900 text-white border-gray-400'
                        : '',
                    ]"
                    :key="index"
                    v-for="(option, index) in el.question
                      .coursequizanswer_set"
                    @click="handleAnswerClick(option.is_correct, option.id)"
                  >
                    {{ option.answer_text }}
                  </button>
                </div> -->

          <div
            class="flex flex-col flex-wrap justify-center gap-4 w-full"
            v-if="el.question.choice_type == 'matchthefollowing'"
          >
            <div class="grid grid-cols-2 gap-10 pt-5">
              <div class="flex flex-col gap-2">
                <div
                  v-for="left_items in el.match_answer.left_items"
                  :key="left_items"
                  class="text-sm px-5 py-2 bg-gray-100"
                >
                  Question: {{ left_items.value }}
                </div>
              </div>
              <draggable
                :list="el.match_answer.right_items"
                class="dragArea list-group w-full flex flex-col gap-2"
              >
                <div
                  v-for="right_items in el.match_answer.right_items"
                  :key="right_items"
                  class="text-sm px-5 py-2 bg-gray-200 cursor-pointer"
                >
                  {{ right_items.value }}
                </div>
              </draggable>
            </div>

            <br />
          </div>

          <div class="flex items-center gap-2">
            <div class="space-y-1">
              <!-- Question Mark -->
              <div
                v-if="el.question.max_mark != null"
                class="flex gap-3 text-sm"
              >
                <span class="text-gray-500">Question Mark:</span>
                <span class="font-medium text-gray-800">{{
                  el.question.max_mark
                }}</span>
              </div>

              <!-- Student Mark -->
              <div v-if="el.mark != null" class="flex gap-3 text-sm">
                <span class="text-gray-500">Student Mark:</span>
                <span class="font-medium text-green-600">{{ el.mark }}</span>
              </div>
            </div>
            <div
              v-if="el.question.max_mark != null"
              class="flex items-center gap-2 hidden"
            >
              <input
                type="number"
                :value="el.mark"
                class="getmark border py-1 px-2 rounded-lg"
                :id="'text' + el.id"
              />
              <div class="flex justify-end items-center gap-3 pb-4 mt-3">
                <button
                  class="rounded-xl px-5 py-1.5 text-sm"
                  @click="addMarkPatch(el.id, el.question.max_mark)"
                  :disabled="disable_submit == true"
                  :class="
                    this.disable_submit == true
                      ? 'bg-gray-200 text-black cursor-not-allowed'
                      : 'bg-primary cursor-pointer text-white'
                  "
                >
                  Update Mark
                </button>
                <img
                  v-if="disable_submit"
                  src="@/assets/loading.gif"
                  alt="loading"
                  class="w-6 h-6 object-contain"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="overflow-y-auto pb-10 max-w-4xl mx-auto px-4">
        <div class="grid grid-cols-2 md:grid-cols-5 gap-4 my-6">
          <div
            class="bg-blue-50 border border-blue-100 rounded-2xl p-4 text-center"
          >
            <p
              class="text-xs font-semibold text-blue-600 uppercase tracking-wider"
            >
              Total
            </p>
            <p class="text-2xl font-bold text-blue-900 mt-1">
              {{ dataval.coursequizusersanswer_set.length }}
            </p>
          </div>

          <div
            class="bg-green-50 border border-green-100 rounded-2xl p-4 text-center"
          >
            <p
              class="text-xs font-semibold text-green-600 uppercase tracking-wider"
            >
              Correct
            </p>
            <p class="text-2xl font-bold text-green-900 mt-1">
              {{
                dataval.coursequizusersanswer_set.filter(
                  (el) => el.answer?.is_correct,
                ).length
              }}
            </p>
          </div>

          <div
            class="bg-red-50 border border-red-100 rounded-2xl p-4 text-center"
          >
            <p
              class="text-xs font-semibold text-red-600 uppercase tracking-wider"
            >
              Wrong
            </p>
            <p class="text-2xl font-bold text-red-900 mt-1">
              {{
                dataval.coursequizusersanswer_set.filter(
                  (el) => el.answer && !el.answer.is_correct,
                ).length
              }}
            </p>
          </div>

          <div
            class="bg-gray-50 border border-gray-200 rounded-2xl p-4 text-center"
          >
            <p
              class="text-xs font-semibold text-gray-500 uppercase tracking-wider"
            >
              Skipped
            </p>
            <p class="text-2xl font-bold text-gray-700 mt-1">
              {{
                dataval.coursequizusersanswer_set.filter((el) => !el.answer)
                  .length
              }}
            </p>
          </div>

          <div
            class="bg-purple-50 border border-purple-100 rounded-2xl p-4 text-center col-span-2 md:col-span-1"
          >
            <p
              class="text-xs font-semibold text-purple-600 uppercase tracking-wider"
            >
              Score
            </p>
            <p class="text-2xl font-bold text-purple-900 mt-1">
              {{
                dataval.coursequizusersanswer_set.reduce(
                  (acc, el) => acc + (el.mark || 0),
                  0,
                )
              }}
            </p>
          </div>
        </div>

        <hr class="border-gray-200 my-6" />

        <div
          v-for="(el, index) in dataval.coursequizusersanswer_set"
          :key="index"
          class="bg-white border border-gray-200 shadow-sm rounded-3xl p-6 md:p-8 mt-6 text-start transition-all hover:shadow-md"
        >
          <div
            class="flex flex-col md:flex-row md:items-start justify-between gap-4 border-b border-gray-100 pb-4"
          >
            <h3 class="text-base font-bold text-gray-900 leading-relaxed">
              <span class="text-gray-400 mr-1">{{ index + 1 }}.</span>
              {{ el.question.question_text }}
            </h3>

            <div class="flex items-center gap-2 shrink-0">
              <span
                v-if="el.question.max_mark != null"
                class="inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium bg-gray-100 text-gray-600"
              >
                Max: {{ el.question.max_mark }}
              </span>
              <span
                v-if="el.mark != null"
                class="inline-flex items-center gap-1 px-2.5 py-1 rounded-md text-xs font-medium bg-green-50 text-green-700 border border-green-200"
              >
                Scored: {{ el.mark }}
              </span>
            </div>
          </div>

          <div class="mt-4 space-y-2">
            <div
              v-for="(al, aIndex) in el.question.coursequizanswer_set"
              :key="aIndex"
              class="flex items-center p-3 rounded-xl border text-sm transition-colors"
              :class="[
                al.is_correct
                  ? 'bg-blue-50/50 border-blue-200 text-blue-950 font-semibold'
                  : 'border-gray-100 text-gray-600',
              ]"
            >
              <span
                class="w-6 h-6 flex items-center justify-center rounded-full text-xs mr-3 shrink-0"
                :class="
                  al.is_correct
                    ? 'bg-blue-600 text-white'
                    : 'bg-gray-100 text-gray-500'
                "
              >
                {{ String.fromCharCode(65 + aIndex) }}
              </span>
              <span>{{ al.answer_text }}</span>
              <span
                v-if="al.is_correct"
                class="ml-auto text-xs font-bold text-blue-600 uppercase px-2"
              >
                Correct
              </span>
            </div>
          </div>

          <div v-if="el.question.choice_type === 'choice'" class="mt-6">
            <div
              v-if="el.answer"
              class="flex items-center gap-3 p-4 rounded-2xl border"
              :class="[
                el.answer.is_correct
                  ? 'bg-green-50 border-green-200 text-green-900'
                  : 'bg-red-50 border-red-200 text-red-900',
              ]"
            >
              <div class="p-2 rounded-xl bg-white shadow-sm shrink-0">
                <svg
                  v-if="el.answer.is_correct"
                  class="w-5 h-5 text-green-600"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2.5"
                    d="M5 13l4 4L19 7"
                  ></path>
                </svg>
                <svg
                  v-else
                  class="w-5 h-5 text-red-500"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2.5"
                    d="M6 18L18 6M6 6l12 12"
                  ></path>
                </svg>
              </div>
              <div>
                <p
                  class="text-xs font-medium text-gray-500 uppercase tracking-wider"
                >
                  Your Answer
                </p>
                <p class="text-sm font-bold mt-0.5">
                  {{ el.answer.answer_text }}
                </p>
              </div>
            </div>

            <div
              v-else
              class="flex items-center gap-3 p-4 rounded-2xl border border-dashed border-gray-300 bg-gray-50 text-gray-500"
            >
              <svg
                class="w-5 h-5 text-gray-400 shrink-0"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                ></path>
              </svg>
              <div>
                <p
                  class="text-xs font-medium text-gray-400 uppercase tracking-wider"
                >
                  Your Answer
                </p>
                <p class="text-sm font-semibold mt-0.5">Not Attended</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- new preview -->

    <div class="w-full max-w-[1200px] mx-auto p-10 flex flex-col gap-4 h-full">
      <div class="flex justify-end">
        <button
          @click="$router.go(-1)"
          class="bg-blues hover:bg-blue-600 text-white px-4 font-semibold text-sm py-1 rounded-xl"
        >
          Back
        </button>
      </div>
      <!-- Loading -->
      <div v-if="loading" class="flex items-center justify-center py-20">
        <div class="relative w-12 h-12">
          <div
            class="absolute inset-0 border-4 border-blue-200 rounded-full"
          ></div>
          <div
            class="absolute inset-0 border-4 border-blue-600 rounded-full animate-spin border-t-transparent"
          ></div>
        </div>
      </div>
      <!-- No Data -->
      <div
        v-else-if="
          !dataval ||
          !dataval.coursequizusersanswer_set ||
          dataval.coursequizusersanswer_set.length === 0
        "
        class="flex flex-col items-center justify-center py-20"
      >
        <svg
          class="w-16 h-16 text-gray-300"
          fill="none"
          stroke="currentColor"
          viewBox="0 0 24 24"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            stroke-width="1.5"
            d="M9 17h6M9 13h6M9 9h6M5 5h14v14H5z"
          />
        </svg>

        <h3 class="mt-4 text-lg font-semibold text-gray-700">No Data Found</h3>

        <p class="text-sm text-gray-500 mt-1">No quiz answers are available.</p>
      </div>
      <div v-else class="overflow-y-auto pb-10 w-full">
        <div>
          <h2 class="text-xl font-bold text-gray-800 break-words">
            {{ dataval?.quiz.name }}
          </h2>
        </div>

        <div v-if="dataval != null" class="overflow-y-auto pb-10 w-full">
          <div
            class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 my-6"
          >
            <div
              class="bg-blue-50 border border-blue-100 rounded-2xl p-4 text-center shadow-sm"
            >
              <p
                class="text-xs font-semibold text-blue-600 uppercase tracking-wider"
              >
                Total Qns
              </p>
              <p class="text-2xl font-black text-blue-900 mt-1">
                {{ dataval.coursequizusersanswer_set.length }}
              </p>
            </div>

            <div
              class="bg-green-50 border border-green-100 rounded-2xl p-4 text-center shadow-sm"
            >
              <p
                class="text-xs font-semibold text-green-600 uppercase tracking-wider"
              >
                Correct
              </p>
              <p class="text-2xl font-black text-green-900 mt-1">
                {{
                  dataval.coursequizusersanswer_set.filter(
                    (el) => el.answer?.is_correct,
                  ).length
                }}
              </p>
            </div>

            <div
              class="bg-red-50 border border-red-100 rounded-2xl p-4 text-center shadow-sm"
            >
              <p
                class="text-xs font-semibold text-red-600 uppercase tracking-wider"
              >
                Wrong
              </p>
              <p class="text-2xl font-black text-red-900 mt-1">
                {{
                  dataval.coursequizusersanswer_set.filter(
                    (el) => el.answer && !el.answer.is_correct,
                  ).length
                }}
              </p>
            </div>

            <div
              class="bg-gray-50 border border-gray-200 rounded-2xl p-4 text-center shadow-sm"
            >
              <p
                class="text-xs font-semibold text-gray-500 uppercase tracking-wider"
              >
                Skipped
              </p>
              <p class="text-2xl font-black text-gray-700 mt-1">
                {{
                  dataval.coursequizusersanswer_set.filter((el) => !el.answer)
                    .length
                }}
              </p>
            </div>

            <div
              class="bg-purple-50 border border-purple-100 rounded-2xl p-4 text-center shadow-sm"
            >
              <p
                class="text-xs font-semibold text-purple-600 uppercase tracking-wider"
              >
                My Score
              </p>
              <p class="text-2xl font-black text-purple-900 mt-1">
                {{
                  Number(
                    dataval.coursequizusersanswer_set.reduce(
                      (acc, el) => acc + (Number(el.mark) || 0),
                      0,
                    ),
                  )
                }}
              </p>
            </div>

            <div
              class="bg-amber-50 border border-amber-100 rounded-2xl p-4 text-center shadow-sm"
            >
              <p
                class="text-xs font-semibold text-amber-600 uppercase tracking-wider"
              >
                Max Score
              </p>
              <p class="text-2xl font-black text-amber-900 mt-1">
                {{
                  Number(
                    dataval.coursequizusersanswer_set.reduce(
                      (acc, el) => acc + (Number(el.question?.max_mark) || 0),
                      0,
                    ),
                  )
                }}
              </p>
            </div>
          </div>

          <hr class="border-gray-200 my-6" />

          <div
            v-for="(el, index) in dataval.coursequizusersanswer_set"
            :key="index"
            class="bg-white border border-gray-200 shadow-sm rounded-3xl p-6 md:p-8 mt-6 text-start transition-all hover:shadow-md"
          >
            <div
              class="flex flex-col md:flex-row md:items-start justify-between gap-4 border-b border-gray-100 pb-4"
            >
              <h3 class="text-base font-bold text-gray-900 leading-relaxed">
                <span class="text-gray-400 mr-1">{{ index + 1 }}.</span>
                {{ el.question.question_text }}
              </h3>
              <div class="flex items-center gap-2 shrink-0">
                <span
                  v-if="el.mark != null || el.question.max_mark != null"
                  class="inline-flex items-center gap-1 px-3 py-1 rounded-full text-xs font-medium bg-blue-50 border border-blue-200"
                >
                  <span class="font-semibold text-green-600">Score</span>

                  <span class="font-bold text-green-600">
                    {{ Number(el.mark ?? 0) }}
                  </span>

                  <span class="text-gray-500">Out of</span>

                  <span class="font-bold text-blue-700">
                    {{ Number(el.question.max_mark ?? 0) }}
                  </span>
                </span>
              </div>
            </div>

            <div class="mt-4 space-y-2">
              <div
                v-for="(al, aIndex) in el.question.coursequizanswer_set"
                :key="aIndex"
                class="flex items-center p-3 rounded-xl border text-sm transition-colors"
                :class="[
                  al.is_correct
                    ? 'bg-blue-50/50 border-blue-200 text-blue-950 font-semibold'
                    : 'border-gray-100 text-gray-600',
                ]"
              >
                <span
                  class="w-6 h-6 flex items-center justify-center rounded-full text-xs mr-3 shrink-0"
                  :class="
                    al.is_correct
                      ? 'bg-blue-600 text-white'
                      : 'bg-gray-100 text-gray-500'
                  "
                >
                  {{ String.fromCharCode(65 + aIndex) }}
                </span>
                <span>{{ al.answer_text }}</span>
                <span
                  v-if="al.is_correct"
                  class="ml-auto text-xs font-bold text-blue-600 uppercase px-2"
                >
                  Correct
                </span>
              </div>
            </div>

            <div v-if="el.question.choice_type === 'choice'" class="mt-6">
              <div
                v-if="el.answer"
                class="flex items-center gap-3 p-4 rounded-2xl border"
                :class="[
                  el.answer.is_correct
                    ? 'bg-green-50 border-green-200 text-green-900'
                    : 'bg-red-50 border-red-200 text-red-900',
                ]"
              >
                <div class="p-2 rounded-xl bg-white shadow-sm shrink-0">
                  <svg
                    v-if="el.answer.is_correct"
                    class="w-5 h-5 text-green-600"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2.5"
                      d="M5 13l4 4L19 7"
                    ></path>
                  </svg>
                  <svg
                    v-else
                    class="w-5 h-5 text-red-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                  >
                    <path
                      stroke-linecap="round"
                      stroke-linejoin="round"
                      stroke-width="2.5"
                      d="M6 18L18 6M6 6l12 12"
                    ></path>
                  </svg>
                </div>
                <div>
                  <p
                    class="text-xs font-medium text-gray-500 uppercase tracking-wider"
                  >
                    Your Answer
                  </p>
                  <p class="text-sm font-bold mt-0.5">
                    {{ el.answer.answer_text }}
                  </p>
                </div>
              </div>

              <div
                v-else
                class="flex items-center gap-3 p-4 rounded-2xl border border-dashed border-gray-300 bg-gray-50 text-gray-500"
              >
                <svg
                  class="w-5 h-5 text-gray-400 shrink-0"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
                <div>
                  <p
                    class="text-xs font-medium text-gray-400 uppercase tracking-wider"
                  >
                    Your Answer
                  </p>
                  <p class="text-sm font-semibold mt-0.5">Not Attended</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import InstructorHeader from "@/components/Instructor/Header.vue";
import HodHeader from "@/components/Hod/Header.vue";
import AdminHeader from "@/components/Admin/Header.vue";
import CoordinateHeader from "@/components/Coordinate/Header.vue";
import Footer from "@/components/Footer.vue";
import axios from "axios";
import { mapActions, mapGetters } from "vuex";
import FlashMessage from "@/components/FlashMessage.vue";
import MonacoEditor from "monaco-editor-vue3";

export default {
  name: "testMCqview",
  data() {
    return {
      currentQuestion: 0,
      countDown: 840,
      showScore: false,
      questions: [],
      tst: false,
      score: 0,
      is_completed: false,
      is_submit: false,
      nextquz: 0,
      message: "",
      mcqset: "",
      dataval: null,
      loading: true,
      answeredData: "",
      currentAnsweredQuestion: 0,
      messages: {
        text: "",
        type: "null",
      },
      disable_submit: false,
    };
  },
  props: ["course_id", "quiz_id", "taker_id"],

  computed: mapGetters([
    "isAuthenticated",
    "userInfo",
    "profileInfo",
    "cartInfo",
    "courseTrackerInfo",
    "subscriptionInfo",
  ]),
  components: {
    FlashMessage,
    InstructorHeader,
    HodHeader,
    AdminHeader,
    CoordinateHeader,
    Footer,
    MonacoEditor,
  },

  async created() {
    this.mcqCall();
    this.tst = false;
    this.countDownTimer();
    this.getQuizDetails();
  },

  mounted() {},

  methods: {
    getQuizDetails() {
      const token = this.userInfo.token_key;

      axios
        .get(
          `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${this.quiz_id}/`,
          {
            params: {
              Key: token,
              id: this.taker_id,
            },
          },
        )
        .then((response) => {
          if (
            response.data.status === 200 &&
            response.data.data &&
            response.data.data.length > 0
          ) {
            this.dataval = response.data.data[0];
          } else {
            this.dataval = {};
          }
        })
        .catch((error) => {
          console.error("Quiz Details Error:", error);
          this.dataval = {};
        })
        .finally(() => {
          this.loading = false;
        });
    },
    formatOutput(output) {
      try {
        ``;
        const outputArray = JSON.parse(output);

        return outputArray.join("\n");
      } catch (e) {
        return output;
      }
    },
    async addMarkPatch(id, max_mark) {
      this.disable_submit = true;
      if (max_mark == null) {
        await axios
          .patch(
            `${process.env.VUE_APP_API}/course-quiz-answer/${id}/?Key=${this.userInfo.token_key}`,
            { mark: document.getElementById(`text${id}`).value },
          )
          .then((response) => {
            this.disable_submit = false;
            this.messages = {
              text: "Mark Updated.",
              type: "success",
            };
            this.getSUbmittedQuiz();
            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
            }, 2000);
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        let markss = document.getElementById(`text${id}`).value;
        if (markss <= max_mark) {
          await axios
            .patch(
              `${process.env.VUE_APP_API}/course-quiz-answer/${id}/?Key=${this.userInfo.token_key}`,
              { mark: document.getElementById(`text${id}`).value },
            )
            .then((response) => {
              this.disable_submit = false;
              this.messages = {
                text: "Mark Updated.",
                type: "success",
              };
              this.getSUbmittedQuiz();
              setTimeout(() => {
                this.messages = {
                  text: "",
                  type: "",
                };
              }, 2000);
            })
            .catch((error) => {
              console.log(error);
            });
        } else {
          this.messages = {
            text: "Mark is less than the max mark.",
            type: "message",
          };
          this.getSUbmittedQuiz();
          setTimeout(() => {
            this.messages = {
              text: "",
              type: "",
            };
          }, 2000);
        }
      }
    },

    async mcqCall() {
      // course_quizzes_pk
      let token = this.userInfo.token_key;
      await axios
        .get(
          `${process.env.VUE_APP_API}/course_quizzes_pk/${this.quiz_id}/?Key=${token}`,
        )
        .then((r) => {
          this.mcqset = r.data.data[0];
          console.log(this.mcqset.quiz.coursequizquestion_set);
          this.questions = r.data.data[0].quiz.coursequizquestion_set;

          if (this.questions) {
            this.questions.forEach((el) => {
              el.ansclk = "";
              el.anr = false;
            });
          }
        });
    },

    handleAnswerClick(isCorrect, id) {
      this.questions[this.currentQuestion].ansclk = id;
      this.questions[this.currentQuestion].anr = isCorrect;
      let nextQuestion = this.currentQuestion + 1;

      if (nextQuestion < this.questions.length) {
        this.currentQuestion = nextQuestion;
      }
    },
    countDownTimer() {
      if (this.countDown > 0) {
        this.timer = setTimeout(() => {
          this.countDown -= 1;
          this.countDownTimer();
        }, 1000);
      }
    },
    submitMcq() {
      this.showScore = true;
      localStorage.setItem("mcqTstv", true);
      this.tst = true;
    },
    nxtQt() {
      let nextQuestion = this.currentQuestion + 1;
      if (nextQuestion < this.questions.length) {
        this.currentQuestion = nextQuestion;
      }
    },
    pvsQt() {
      if (this.currentQuestion > 0) {
        let nextQuestion = this.currentQuestion - 1;
        if ((nextQuestion) => 0) {
          this.currentQuestion = nextQuestion;
        }
      }
    },

    nxtQtSubmitted() {
      if (
        this.currentAnsweredQuestion <
        this.dataval.coursequizusersanswer_set.length
      ) {
        this.currentAnsweredQuestion = this.currentAnsweredQuestion + 1;
      }
    },

    pvsQtSubmitted() {
      if (this.currentAnsweredQuestion > 0) {
        this.currentAnsweredQuestion = this.currentAnsweredQuestion - 1;
      }
    },

    async getSUbmittedQuiz() {
      let token = this.userInfo.token_key;

      axios
        .get(
          `${process.env.VUE_APP_API}/quiztaker__quizzes_pk/${this.quiz_id}/?Key=${token}&id=${this.taker_id}`,
        )
        .then((response) => {
          if (response.data.status == 200) {
            this.dataval = response.data.data[0];
            console.log(response.data.data, "response.data.data");
          }
          console.log("response:: test", response.data.message);
        });
    },

    async ckans() {
      var ans_set = [];
      let token = this.userInfo.token_key;
      this.questions.forEach((el) => {
        let val = {
          question: el.id,
          answer: el.ansclk,
          description: el.description,
          short_description: el.short_description,
        };
        ans_set.push(val);
        if (el.anr) {
          this.score += 1;
        }
      });

      this.HeaderVal = {
        score: this.score,
        quiz: this.mcqset.quiz.course,
        quiz_id: this.mcqset.quiz.id,
        quiz_title: this.mcqset.quiz.name,
        usersanswer: ans_set,
        completed: true,
      };
      await axios
        .patch(
          `${process.env.VUE_APP_API}/course_save_multi_answer/?Key=${token}`,
          this.HeaderVal,
        )
        .then((response) => {
          console.log("response", response);

          // this.quizPreview();

          if (response.data.status == 200) {
            this.messages = {
              text: "Quiz Submitted.",
              type: "success",
            };

            setTimeout(() => {
              this.messages = {
                text: "",
                type: "",
              };
              this.getSUbmittedQuiz();

              this.$emit("pushLessonComplete");
            }, 2000);

            this.getSUbmittedQuiz();
          }
        });
    },
  },
};
</script>

<style scoped>
.gradient-btn {
  background: #0f172a;
  --tw-shadow: 0 10px 30px -3px rgba(255, 31, 57, 0.1),
    0 10px 30px -6px rgba(255, 31, 57, 0.3);
  transition: all 0.2s linear;
  color: white;
  border: 0px;
  padding: 8px 16px;
  outline: 2px solid transparent;
  outline-offset: 2px;
  border-radius: 0.25rem;
  font-size: 1rem;
  line-height: 1.5rem;
  min-width: 160px;
  font-weight: 700;
}
</style>
